<template>
  <el-select
    ref="state"
    v-model="selected"
    :multiple="multiple"
    clearable
    filterable
    collapse-tags
    :placeholder="$t('selecione-uma-opcao')"
    @change="update()"
  >
    <el-option
      v-for="row of tableState"
      :key="row.state"
      :label="`${row.state} - ${row.name}`"
      :value="row.state"
    ></el-option>
  </el-select>
</template>

<script>
import { BoundaryService } from "@/services/shipping/boundary.services";
export default {
  props: ["multiple", "current"],
  name: "CapitalStateList",
  data: function () {
    return {
      tableState: [],
      selected: "",
    };
  },
  watch: {
    current() {
      this.selected = this.$props.current;
    },
  },
  methods: {
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      BoundaryService.list()
        .then((response) => {
          vm.tableState = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    update() {
      const vm = this;
      console.log(vm.selected)
      if (Array.isArray(vm.selected)) {
        if (vm.selected.length === 1) {
          const stateData = vm.tableState.find(x => x.state === vm.selected[0]);
          console.log('update 123', stateData)
          vm.$emit("input", {
            ...stateData,
            state: vm.selected,
          });
          vm.$emit("selected", {
            ...stateData,
            state: vm.selected,
          });
        } else {
          vm.$emit("input", {
            state: vm.selected,
          });
          vm.$emit("selected", {
            state: vm.selected,
          });
        }
      } else {
        const stateData = vm.tableState.find(x => x.state === vm.selected);
        console.log('update', stateData)
        vm.$emit("input", stateData);
        vm.$emit("selected", stateData);
      }
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>